import React, { Fragment } from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { Tooltip, Button, Paper, FormGroup, FormControlLabel, Checkbox } from '@material-ui/core';
import MaterialTable from 'material-table';
import { Lock, LockOpen, VpnKey, Edit, AddBox } from '@material-ui/icons';
import { ExportToCsv } from 'export-to-csv';
import User from '../../../models/User';
import roles from '../../../configs/roles';
import userStyles from './userManagement.module.css';
import commonStyles from '../../common/common.module.css';

const iconFontSize = 20;

const styles = (theme: Theme) =>

  createStyles({
    materialIcon: {
      color: 'rgba(0, 0, 0, 0.87)',
      padding: '0px 6px 0px',
      fontSize: iconFontSize,
      '&:hover': {
        cursor: 'pointer'
      }
    },
    disabledIcon: {
      fontSize: iconFontSize,
      padding: '0px 6px 0px',
      color: 'rgb(204, 204, 204)'
    },
    priorityHigh: {
      color: '#FF0000',
      fontSize: '15px'
    }, button: {
      height: '40px',
      marginBottom: '30px'
    }, exportButton: {
      height: '40px',
      marginBottom: '30px',
      marginRight: '10px'
    },
  });

interface UserManagementProps {
  classes: any;
  users: User[];
  inactive: boolean;
  openDectivateUserModal: (id: number) => void;
  openResetUserPasswordModal: (user: any) => void;
  openEditUserModal: (type: 'create' | 'update' | 'reactivate', user?: any) => void;
  openAirlineRepModal: (type: 'create' | 'update' | 'reactivate', user?: any) => void;
  onFilterChange: (value: boolean) => void;
};

const Awbs = (props: UserManagementProps) => {

  const { classes } = props;

  const downloadUsersExcel = (): void => {
    const headers = ['Name', 'Email/Username', 'Role', 'Status'];
    const data = props.users.map((user: any) => [
      `${user.first_name || ''} ${user.last_name || ''}`.trim(),
      user.email || '',
      user.id_user_role ? roles.userRoleToString(user.id_user_role) : '',
      user.verified ? 'Active' : 'Inactive'
    ]);

    const csvExporter = new ExportToCsv({
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      showTitle: false,
      filename: 'users',
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: false,
      headers
    });

    csvExporter.generateCsv(data);
  };

  return (
    <Fragment>
      <div className={commonStyles.headerDummyDiv}></div>
      <div style={{ textAlign: 'right', paddingBottom: '40px' }}>
        <div>
          <Button
            color="primary"
            variant="outlined"
            onClick={downloadUsersExcel}
            className={props.classes.exportButton}
          >DOWNLOAD USERS</Button>
          <Button
            color="primary"
            variant="contained"
            onClick={() => { props.openEditUserModal('create') }}
            className={props.classes.button}
          >ADD NEW USER</Button>
        </div>
        <div className={`${commonStyles.wrapper} ${userStyles.wrapper} ${userStyles.usertable}`} >
          <div className={commonStyles.fSpaceBtw}>
            <h3 className={commonStyles.header}> User List</h3>
            <FormGroup
              row={true}
              className={`${commonStyles.ussFormGroup}`}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="transit_shipments"
                    color="primary"
                    size="small"
                  />
                }
                label="Inactive Users"
                checked={props.inactive}
                onClick={() => props.onFilterChange(!props.inactive)}
                className={`${commonStyles.exclCheckbox} ${commonStyles.mb2} ${commonStyles.mr0}`}
              />
            </FormGroup>
          </div>
          <MaterialTable
            components={{ Container: props => <Paper {...props} elevation={0} className={commonStyles.paperTable} /> }}
            columns={[
              {
                title: 'Name', field: '', cellStyle: { minWidth: '150px' }, render: (user: any) => {
                  return `${user.first_name} ${user.last_name}`;
                }, customFilterAndSearch: (term, user: any) => `${user.first_name} ${user.last_name}`.toLowerCase().indexOf(term.toLowerCase()) !== -1
              },
              { title: 'Email/Username', field: 'email', cellStyle: { minWidth: '150px' }, customFilterAndSearch: (term, user) => user.email.toLowerCase().indexOf(term.toLowerCase()) !== -1 },
              {
                title: 'Role', field: '', cellStyle: { minWidth: '150px' }, render: (user: any) => {
                  if (user.id_user_role) {
                    return roles.userRoleToString(user.id_user_role);
                  }
                  return '';
                }, customFilterAndSearch: (term, user) => {
                  if (user.id_user_role) {
                    return roles.userRoleToString(user.id_user_role).toLowerCase().indexOf(term.toLowerCase()) !== -1;
                  }
                  return false;
                }
              },
              {
                title: 'Action', headerStyle: { textAlign: 'left' }, cellStyle: { minWidth: '150px' },
                render: (user: any) => {
                  return <span className={userStyles.actionList} >
                    {user.verified ? <Tooltip title="Deactivate user">
                      <Lock className={classes.materialIcon} onClick={() => { props.openDectivateUserModal(user.id) }} />
                    </Tooltip> :
                      <Tooltip title="Activate user">
                        <LockOpen className={classes.materialIcon} onClick={() => { props.openEditUserModal('reactivate', user); }} />
                      </Tooltip>}

                    <Tooltip title="Change password">
                      <VpnKey className={user.verified ? classes.materialIcon : classes.disabledIcon} onClick={user.verified ? () => { props.openResetUserPasswordModal(user) } : () => { }} />
                    </Tooltip>

                    <Tooltip title="Edit user">
                      <Edit className={user.verified ? classes.materialIcon : classes.disabledIcon} onClick={user.verified ? () => { props.openEditUserModal('update', user); } : () => { }} />
                    </Tooltip>
                    {user.id_user_role === 13 ? <Tooltip title="Add carrier to user">
                      <AddBox className={user.verified ? classes.materialIcon : classes.disabledIcon} onClick={user.verified ? () => { props.openAirlineRepModal('update', user); } : () => { }} />
                    </Tooltip> : ''}
                  </span>;
                }
              }
            ]}

            data={props.users}

            options={{
              paging: false,
              pageSize: 10,
              headerStyle: {
                backgroundColor: 'var(--tbl_head_bkg)',
                color: 'var(--tbl_head_color)',
                zIndex: 2,
              },
              showTitle: false,
              pageSizeOptions: [15, 20],
              toolbar: false,
              sorting: false,
              filtering: true,
            }}
          />
        </div>
      </div>
    </Fragment>
  )
}

export default withStyles(styles)(Awbs);